module.exports = __webpack_public_path__ + "static/media/shopping-bag.7118849a.svg";